import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { UserService } from '../../users/user.service';
import { ProcessorCloserReassignmentService } from '../../processor-closer-pipeline-reassignment/processor-closer-reassignment.service';
import { User } from '../../users/user.model';
import { ReassignmentBaseDto } from '../reassignment';
import { MatDialog } from '@angular/material';
import { UwReshuffleDialogComponent } from '../../uw-reshuffle-dialog/uw-reshuffle-dialog.component';


@Component({
    selector: 'app-closer-reassignment',
    templateUrl: './closer-reassignment.component.html',
    styleUrls: ['./closer-reassignment.component.css']
})
export class CloserReassignmentComponent implements OnInit {

    public closerUsers: User[];
    public activeCloserUsers: User[];
    public CloserReassignForm: FormGroup;
    public allClosers = [];
    public allActiveClosers = [];
    public searchValue: string = null;
    public searchActiveValue: string = null;
    public selectedClosers: User[] = [];
    public currentCloser: User;
    public isLoading: boolean = false;
    public inputMessage: string = "";
    public successErrorMessgae: string = "";
    public DataFound: boolean = false;
    public assignedLoans = [];
    public unAssignedLoans = [];
    public showNewCloser: boolean = false;
    public showReassignButton: boolean = false;
    @Output() close: EventEmitter<any> = new EventEmitter();

    constructor(
        private dialog: MatDialog,
        private fb: FormBuilder,
        public userService: UserService,
        public processorCloserReassignementService: ProcessorCloserReassignmentService
    ) {
        this.CloserReassignForm = this.fb.group({
            allCloserSelection: [null],
            closerSelection: [null]
        });
    }

    async ngOnInit() {
        await this.getHistoricalUsers();
        await this.getCloserUsers();
    }

    async getHistoricalUsers() {

        this.isLoading = true;
        this.inputMessage = "";

        await this.processorCloserReassignementService.getHistoricalCloserUsers().then(
            result => {
                if (result != null && result.length > 0) {
                    this.allClosers = JSON.parse(JSON.stringify(result));
                    this.closerUsers = JSON.parse(JSON.stringify(result));
                    this.DataFound = true;
                    this.isLoading = false;
                } else {
                    this.isLoading = false;
                    this.DataFound = false;
                    var message = "No Closer User Loans are available for Reassignment."
                    this.showMessage(message, null, null);

                }
            }
        )
            .catch(error => {
                console.log(error)
                this.isLoading = false;
                this.inputMessage = "";
            });
    }

    async getCloserUsers() {
        this.isLoading = true;
        this.inputMessage = "";
        await this.userService.getUsersByPersona('Sr Closer').then(
            result => {
                this.allActiveClosers = JSON.parse(JSON.stringify(result));
                this.allActiveClosers.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));

                this.activeCloserUsers = JSON.parse(JSON.stringify(result));
                this.activeCloserUsers.sort((a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName));

                this.isLoading = false;
            }
        )
            .catch(error => {
                console.log(error)
                this.isLoading = false;
                this.inputMessage = "";
            });
    }

    onSearchChange(event) {
        if (this.searchValue) {
            this.closerUsers = this.allClosers.filter(value => value.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        }
        else {
            this.closerUsers = this.allClosers;
        }

    }


    onSearchActiveUsersChange(event) {
        if (this.searchActiveValue) {
            this.activeCloserUsers = this.allActiveClosers.filter(value => value.name.toLowerCase().includes(this.searchActiveValue.toLowerCase()));
            this.selectedClosers.forEach(value => {
                if (!this.activeCloserUsers.includes(value)) {
                    this.activeCloserUsers.push(value)
                }
            });
        }
        else {
            this.activeCloserUsers = [...this.allActiveClosers];
        }
    }


    onSelectionChange(event) {
        if (event.value.length > 0) {
            event.value.forEach(val => {
                if (!this.selectedClosers.includes(val)) {
                    this.selectedClosers.push(val);
                }
            })
            let tempUsers = [...this.selectedClosers];
            tempUsers.forEach((val, index) => {
                if (!event.value.includes(val)) {
                    this.selectedClosers.splice(index, 1);
                }
            })
        }
        else {
            this.selectedClosers = [];
        }
        if (this.selectedClosers != null && this.selectedClosers.length > 0) {
            this.showReassignButton = true;
        } else {
            this.showReassignButton = false;
        }
    }

    onCurrentCloserSelectionChange(event) {
        this.currentCloser = event.value;
        if (this.currentCloser != null) {
            this.showNewCloser = true
        } else {
            this.showNewCloser = false;
        }
    }

    async reassignLoans() {
        await this.getLoansbyUserandPersona(this.currentCloser);
    }

    async getLoansbyUserandPersona(user: User) {
        this.isLoading = true;
        this.inputMessage = "Fetching loans, please wait...";
        await this.processorCloserReassignementService.getLoansbyUserAndPersona(user, 'Sr Closer').then(async result => {
            this.inputMessage = "Fetching Completed,Reassignment Start";
            await this.finalReassignment(result);
        })
            .catch(error => {
                console.log(error)
                this.isLoading = false;
                this.inputMessage = "";
            });
    }

    async finalReassignment(reassignmentData) {
        var count: number = 0;
        this.isLoading = true;
        this.inputMessage = "Fetching Completed,Reassignment Start";
        await this.makeFinalReassignment(reassignmentData, count)
    }

    async makeFinalReassignment(reassignmentData, count) {
        var res = reassignmentData.pipelineLoanDtos[count];

        var reassignmentBaseDto: ReassignmentBaseDto = new ReassignmentBaseDto();
        this.inputMessage = "Reassigning Loan : " + res.fields["Fields.364"];
        reassignmentBaseDto.Users = [];
        reassignmentBaseDto.Users = this.selectedClosers;
        reassignmentBaseDto.PipelineLoanDtos = [];
        reassignmentBaseDto.PipelineLoanDtos.push(res);
        reassignmentBaseDto.UserLoanAssignmentDtos = reassignmentData.userLoanAssignmentDtos.filter(function (el) { return el.loanNumber == res.fields["Fields.364"] });

        await this.processorCloserReassignementService.makeCloserReassignment(reassignmentBaseDto).then(result => {
            count = count + 1;
            if (result.assignedSuccessfully) {
                this.assignedLoans.push(result.messages[0]);
            } else {
                this.unAssignedLoans.push(res.fields["Fields.364"]);
            }

            if (reassignmentData.pipelineLoanDtos.length > count) {
                this.makeFinalReassignment(reassignmentData, count)
            }
        })
            .catch(error => {
                console.log(error)
                this.isLoading = false;
                this.inputMessage = "";
                this.unAssignedLoans.push(res.fields["Fields.364"]);
            });

        if (count == reassignmentData.pipelineLoanDtos.length) {
            this.isLoading = false;
            this.inputMessage = "";
            this.cleanupReassignment();
        }
    }

    cleanupReassignment = async (): Promise<void> => {
        var message = "Assignment Closer is complete. See below for a list of loans that did get assigned and those that did not.";
        await this.showMessage(message, this.assignedLoans, this.unAssignedLoans);
        this.CloserReassignForm.reset();
        this.currentCloser = null;
        this.allActiveClosers = [];
        this.activeCloserUsers = [];
        this.allClosers = [];
        this.DataFound = false;
        this.assignedLoans = [];
        this.unAssignedLoans = [];
        this.CloserReassignForm.controls["allCloserSelection"].setErrors(null);
        this.CloserReassignForm.controls["closerSelection"].setErrors(null);
    }

    async showMessage(message, assignedLoanList, unAssignedLoanList) {
        var dialogData = [{ "message": message, "LoanList": unAssignedLoanList, "AssignedLoanList": assignedLoanList }];

        let dialogRef = this.dialog.open(UwReshuffleDialogComponent, {
            width: "400px", height: "auto",
            data: dialogData,
        });
        dialogRef.afterClosed().subscribe(result => {
            this.close.emit();
        });
    }

    onDropDownOpen() {
        this.searchActiveValue = null;
        this.searchValue = null;
        this.activeCloserUsers = [... this.allActiveClosers];
        this.closerUsers = [... this.allClosers];
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/closer-reassignment/closer-reassignment.component.ts